<!-- For Ads -->
<ng-container *ngIf="ads; else default">
  <div class="my-card" style="background-color: rgba(var(--secondary-r), var(--secondary-g), var(--secondary-b), 0.75)">
    <div class="image">
      <a [href]="'https://' + list?.url" target="_blank" rel="noopener noreferrer"><img loading="lazy"
          [src]="imgUrl + list.image" class="img-pro" /></a>
    </div>
    <div class="detail">
      <div>
        <div class="detail_title" style="color: white">{{ list.description.substr(0, 60) }}<span
            *ngIf="list.description.length > 60">...</span></div>

        <small *ngIf="list.unit != 'null' && list.unit != 0" style="position: absolute; bottom: 0">{{ list.unit != "Nil"
          ? list.unit : "" }}</small>
      </div>

      <div class="bar">
        <div class="price" style="color: white"><span>$</span>{{ list.price }}</div>
      </div>
      <div class="tag"><span>Ads</span></div>
    </div>
  </div>
</ng-container>
<!-- For Ads -->

<ng-template #changeTag>
  <div class="w-100 d-flex flex-column m-4">
    <p style="color: var(--secondary); font-weight: bold;" class="mb-2">Change Tag Of Product(ADMIN)</p>
    <select style="background: transparent; border: 0px;" (change)="setVerifiedTag($event)">
      <option [selected]="v.toLowerCase() == productData?.verifiedTag"
        *ngFor="let v of ['Verified', 'Quality', 'Value', 'Unique', 'Preferred', 'Top Seller']" [value]="v">{{v}}
      </option>
    </select>

    <div class="mt-3 ">
      Dollar Sign Rating:
      <div   class="dollar-sign-outer" (click)="moduloIncreaseDollarSign()">
        <div class="dollar-sign-inner" [style.width.%]="(list?.dollarSignRating / 3) * 100">
        </div>
      </div>
    </div>
  </div>


</ng-template>

<!-- For Product -->
<ng-template #default>
  <div class="my-card" [ngClass]="{
      'glow-notification': (list.isHighlight && withHighlight) || list.isOnlineStatus
    }" style="display: flex; flex-direction: column; justify-content: start; position: relative">

    <div class="position-absolute d-flex flex-column" style="right: 0.75em; top: 0.75em; z-index: 200;">

      <input *ngIf="canBeSelected" style="accent-color: var(--secondary);" type="checkbox" [(ngModel)]="isSelected"
        (change)="selectedChanged()" />
      <div *ngIf="list?.productMoreServices && list?.productMoreServices?.length" [class.mb-2]="canBeSelected">
        <img src="../../../../../assets/images/promo.png" style="height: 1.3rem; width: auto;" />
      </div>
    </div>


    <div
      style="position: absolute; left: 0.75em; top: 0.75em; z-index: 200; color: var(--secondary); background: rgba(255, 255, 255, 0.5); backdrop-filter: blur(2px); border-radius: 0.25em; width: 2em; height: 2em; display: flex; align-items: center; justify-content: center"
      *ngIf="categoryImage" class="shadow-sm p-2">
      <img [src]="imgUrl + categoryImage" style="filter: var(--primary-filter); height: 1.1em; width: auto" />
    </div>
    <div class="report_status" *ngIf="list.reportCount > 0 && roleService?.roles?.userType?.includes('ADMIN')">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    </div>
    <div class="online_status" *ngIf="list.isShopOwnerOnline">
      <i class="fa fa-circle" aria-hidden="true"></i>
    </div>
    <div class="image">
      <span class="text-nowrap" *ngIf="!list?.isWithinRadius; else withinRadius" class="region" placement="top"
        ngbTooltip="{{ (list?.subRegionName?.split(',').includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}">
        <div *ngIf="list?.hasCrown">
          <span class="glow-crown">
            <i class="fa fa-crown"></i>
          </span>
        </div>
        {{ (list?.subRegionName?.split(",").includes("all") ? "Doorstep" : regionSplit(list?.subRegionName)) |
        titlecase }}
      </span>
      <ng-template #withinRadius>
        <span class="region" placement="top"
          ngbTooltip="{{ (list?.subRegionName?.split(',').includes('all') ? 'Doorstep' : regionSplit(list?.subRegionName)) | titlecase }}">
          {{'\< ' + (list?.distance ?? ' 5km')}} </span>
      </ng-template>

      <div class="product-distance" *ngIf="list.isWithinRadius && list?.type != 'promote'"><i
          class="fa-solid fa-location"></i> {{ list.distance }}</div>

      <div style="position: absolute; top: calc(100% + 0.05em); left: 0"
        class="d-flex justify-content-between w-100 align-items-center">
        @if(roleService.roles?.users?.includes('MEMBER_SHOP_BADGE') && list.points){
        <div class="product-points" style="font-size: .8em;">
          <span class="badge badge-info">XP{{ list.points }} </span>
        </div>
        }@else{
        <span style="width: 1px"></span>
        <!--To avoid collapse-->
        }
        <div class="verified" [class.verified-special-red]="list.verifiedTag?.trim() == 'Top Seller'"
          [class.verified-special]="list.verifiedTag?.trim() == 'Preferred'" *ngIf="isVerified"
          style="width: fit-content; font-size: .8em;" (click)="openEditVerifiedTag()">
          {{ (list.verifiedTag?.trim()?.length ? list.verifiedTag : "Verified").toLowerCase() | titlecase }}
          <div class="rhoumbus-outer " *ngIf="!specialTags.has(list.verifiedTag?.trim())">

            <div class="rhoumbus-inner" [style.width.%]="(list?.verifiedTagRating / 3) * 100"></div>
          </div>
        </div>
      </div>
      <!-- - <div class="product-points" style="position: absolute; bottom: 0; left: 0; z-index: 2;" *ngIf="list?.sellerInfo?.superDealRating  || list?.sellerInfo?.superDealText
      ">
        <span> 
          <img src="../../../../../assets/images/super_deal.png" ngbTooltip="Super Deal" style="width: 2rem; aspect-ratio: 1/1;" />
        </span>
      </div> -->

      <!-- <div class="product-points" style="position: absolute; bottom: 0; left: 0" *ngIf="list.xpCount">
        <span class="badge badge-info" style="background-color: var(--primary)"> <i class="fa-solid fa-medal"></i> {{ list.xpCount }} </span>
      </div> -->


      <!-- if('highQualityRating' in sellerInfo){
        this.otherRatingBadges.push({
          icon: 'high_quality.png',
          name: 'Hight Quality',
          rating: sellerInfo.highQualityRating,
          text: sellerInfo.highQualityText
        }
      } -->

      @if(list.isDeleted){

      <img loading="lazy" src="../../assets/images/shop/deleted.jpg" [class.radius-left]="list.user_detail?.id"
        class="img-pro" (click)="viewProductDetails(list)" [alt]="'Image ' + list.name"
        (error)="commonService.handleError($event)" />
      }@else{
      <!-- <ng-container *ngIf="isBrowser">
          @if(isThereValidCropInformation){ -->
      <app-cropped-image [imgSrc]="imgUrl + list.indexImage" [cropInformation]="list?.mainImageCropInformation"
        [imgAlt]="'Image ' + list.name" (click)="viewProductDetails(list)"></app-cropped-image>
      <!-- }@else{
              <img loading="lazy" [src]="imgUrl + list.indexImage" [class.radius-left]="list.user_detail?.id" 
              class="img-pro" (click)="viewProductDetails(list)" [alt]="'Image ' + list.name" (error)="commonService.handleError($event)" /> 

          }
        </ng-container> -->
      }
      <div *ngIf="list.user_detail?.id && list.user_detail?.shop_logo" class="shop-img" (click)="goToBiz(list)">
        <img loading="lazy" [src]="imgUrl + list.user_detail?.shop_logo" (error)="commonService.handleError($event)" />
        <!-- <span class="badge badge-danger" style="position: absolute; bottom: 0">
          <i class="fa-regular fa-square-plus"></i> {{ list.user_detail?.supportCount }} Support
        </span> -->
      </div>
    </div>
    <!-- <div class ='verified-row'>
      <span *ngIf="isVerified" class ='verified'>{{ (list.verifiedTag ?? "Verified") | titlecase }}</span>
    </div> -->

    <div class="detail">
      <div class="clamped-wrapper">
        <div class="detail_title" (click)="viewProductDetails(list)">

          <span class='prod-name' style="display: inline;">
            @if(list?.companyName?.trim() && list?.companyName?.toLowerCase()?.trim() != 'null'){
            <span class="company-name">
              {{ list.companyName }}
            </span>
            <span class="d-block short"> {{ list.name
              }}
            </span>

            }@else{
            {{ list?.name }}
            }
            {{ list.isDeleted ? " (DELETED)" : "" }}
          </span>
        </div>

      </div>

      <div class="bar">
        @if(list?.foodSpecs && !isCommunityProduct){
        <div class="price" *ngIf="list?.foodSpecs && list?.foodSpecs[0]?.key != '-'"><span>$</span>{{
          list?.foodSpecs[0]?.key }}</div>
        }@else{
        <ng-container *ngIf="list?.memberShopProductsVariations">
          <div class="price">
            <span *ngIf="list?.memberShopProductsVariations[0]?.key > 0">$</span>
            {{ list?.memberShopProductsVariations[0]?.key > 0 ? list?.memberShopProductsVariations[0]?.key : list?.type
            != 'promote' ? "FREE" : '' }}
          </div>
        </ng-container>
        }
        <span class="favorite">
          @if(!(!isLogin && !list?.foodFavoritesCount) && !isUpvote){
          <span class="number">{{ list?.foodFavoritesCount }}</span>
          <i (click)="favoriteProduct(list)" [class.fa-solid]="list?.isFavorite" [class.fa-regular]="!list?.isFavorite"
            class="fa-heart"> </i>

          }
          <!-- <div class="d-flex" style="gap: 0.2rem" *ngIf="isUpvote">
            <span class="vote-buttons">
              <button [class.active]="list?.isFavorite" (click)="favoriteProduct(list)" [disabled]="!isLogin">
                <i class="fa fa-thumbs-up" [ngClass]="list?.isFavorite ? 'fa-solid' : 'fa-regular'"></i>
                <span class="text">
                  {{ list?.isFavorite ? 'Upvoted' : 'Upvote' }}
                </span>
              </button>
            </span>
            <button class="comment-icon" ngbTooltip="Comment" placement="top" (click)="onComment(list)"
              [disabled]="!isLogin">
              <i class="fa fa-comment"></i>
            </button>
          </div> -->
        </span>
      </div>
      <div class="w-100 d-flex justify-content-between align-items-center" [class.mt-2]="isUpvote"
        style="margin-top: 0.1rem">
        <small class="uniform-small d-inline-block">
          {{ list.unit != "null" && list.unit != 0 ? list.unit : ( list?.memberShopProductsVariations &&
          list?.memberShopProductsVariations[0]?.key > 0 ? "From" : "") }}
        </small>

        <span class="d-flex align-items-center" style="min-width: fit-content" *ngIf="isMemberProduct">
          <small class="mr-1">{{ viewCount }}</small>
          <small class="">Views</small>
        </span>
      </div>

      <div class="tag" *ngIf="list?.type">
        <div>
          <!-- <span placement="top" style="z-index: 2;" class="shout-out">
            <img [src]="'../../../../../assets/images/' + otherRatingBadges[0].icon" *ngIf="otherRatingBadges.length"
              [ngbTooltip]="otherRatingBadges[0].name" style="height: 2rem;" />
          </span> -->
          <div  class="dollar-sign-outer">
            <div class="dollar-sign-inner" [style.width.%]="(list?.dollarSignRating / 3) * 100">
            </div>
          </div>
        </div>

        <span class="d-block short pink">
          {{ list.categoryName?.length > 20 ? (list.categoryName | slice:0:20) + '...' : list.categoryName }}
        </span>
      </div>
    </div>
  </div>
  <div class="btn-group vote-section" *ngIf="isUpvote">
    <button class="w-100 vote-button" [class.active]="list?.isFavorite" (click)="favoriteProduct(list)"
      [disabled]="!isLogin">
      <i class="fa fa-thumbs-up" [ngClass]="list?.isFavorite ? 'fa-solid' : 'fa-regular'"></i>
      <span class="text">
        {{ list?.isFavorite ? 'Upvoted' : 'Upvote' }}
      </span>
    </button>
    <button class="w-100 comment-button" (click)="viewProductDetails(list)" [disabled]="!isLogin">
      <i class="fa fa-comment"></i>
      <span class="text">
        Discuss
      </span>
    </button>
  </div>
</ng-template>
<!-- For Product -->